import * as Yup from "yup";
import { Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import { CreditCard, HandCoins, Landmark } from 'lucide-react';
import PaymentMethod from './PaymentMethod';
import { useContext } from "react";
import { PaymentMethods } from "@/types";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";

export type IPaymentForm = {
    paymentMethod: PaymentMethods;
};

export const paymentFormInitialValues = {
    paymentMethod: null,
};

export const PaymentFormSchema = Yup.object().shape({
    paymentMethod: Yup.string().required(),
})

const PaymentForm = () => {
  const formik = useFormikContext<IPaymentForm>();
  const { organization } = useContext(WebsiteContext);

  return (
    <Stack spacing={2}>
      {organization?.settings?.paymentMethods?.includes(PaymentMethods.CASH) ? (
        <PaymentMethod
            label="Efectivo"
            icon={<HandCoins />}
            isChecked={formik.values.paymentMethod === PaymentMethods.CASH}
            onChange={() => formik.setFieldValue("paymentMethod", PaymentMethods.CASH)}
        />
      ) : null}
      {organization?.settings?.paymentMethods?.includes(PaymentMethods.BANK_TRANSFER) ? (
        <PaymentMethod
            label="Transferencia Bancaria"
            icon={<Landmark />}
            isChecked={formik.values.paymentMethod === PaymentMethods.BANK_TRANSFER}
            onChange={() => formik.setFieldValue("paymentMethod", PaymentMethods.BANK_TRANSFER)}
        />
      ) : null}
      {organization?.settings?.paymentMethods?.includes(PaymentMethods.CREDIT_CARD) ? (
        <PaymentMethod
            label="Trajeta de Crédito"
            icon={<CreditCard />}
            isChecked={formik.values.paymentMethod === PaymentMethods.CREDIT_CARD}
            onChange={() => formik.setFieldValue("paymentMethod", PaymentMethods.CREDIT_CARD)}
        />
      ) : null}
    </Stack>
  );
};

export default PaymentForm;
